import React, { PropsWithChildren, ReactNode } from 'react'
import { Menu as MuiMenu, MenuOwnProps } from '@mui/base/Menu'
import classes from './Menu.module.scss'
import { useSlotProps } from '@/components/ui/Menu/Menu.hooks'
import MenuItem from '@/components/ui/Menu/MenuItem'
import { MenuItem as MuiMenuItem } from '@mui/base/MenuItem'
import { Placement } from '@/types'

export type MenuProps = {
  placement?: Placement
} & MenuOwnProps

const Menu = ({ children, placement = 'bottom', ...props }: MenuProps) => {
  const slotProps = useSlotProps(placement)

  return (
    <MuiMenu slotProps={slotProps} {...props}>
      {children}
    </MuiMenu>
  )
}
const Body = ({ children }: PropsWithChildren<object>) => {
  return <div className={classes.body}>{children}</div>
}

const Footer = ({ children }: PropsWithChildren<object>) => {
  return (
    <div className={classes.footer}>
      <MuiMenuItem>{children}</MuiMenuItem>
    </div>
  )
}

Menu.Item = MenuItem
Menu.Body = Body
Menu.Footer = Footer

export default Menu
